module.exports = __webpack_public_path__ + "static/img/p1-2.dca537d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-2.png
// module id = RIOE
// module chunks = 0